import logger from 'utils/logger.util';

const L = logger('parseJson');

const parseJson = (string) => {
  try {
    return JSON.parse(string);
  } catch (e) {
    L.warn('()', e, 'tried to parse:', string);
    return void 1;
  }
};

// noinspection JSUnusedGlobalSymbols
export default parseJson;
